import { DataTypeSearchCombo, SearchQuery } from '../Query';
import { isSearchQuery } from './isSearchQuery';

export const isSearchQueryArray = (
  arr: (SearchQuery | DataTypeSearchCombo)[],
): arr is SearchQuery[] => arr.every(isSearchQuery);
